import { IOption } from '@gcl/react-core';

export const permitToLoadRemoveActionerOptions: IOption<string>[] = [
  { key: 'SRP', text: 'SRP' },
  { key: 'TWC', text: 'TWC' },
  { key: 'ICE', text: 'ICE' },
  { key: '-', text: 'No Action' },
  { key: 'Cancelled', text: 'Cancelled' },
];
